/* eslint-disable */
(function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, collectionsTemplate } = algolia;

  algolia.collectionsPlugin = {
    getSources({ query, setContext }) {
      return [
        {
          sourceId: 'collections',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'collections',
                  query,
                  params: {
                    hitsPerPage: config.collections_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    userToken: localStorage.getItem('aa-user-token')
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbCollections: results[0].nbHits,
                });

                function removeDuplicatesByTitle(items) {
                  const uniqueTitles = {};
                  return items.filter(item => {
                    if (!uniqueTitles[item.title]) {
                      uniqueTitles[item.title] = true;
                      return true;
                    }
                    return false;
                  });
                }

                return removeDuplicatesByTitle(hits[0]).slice(0, 5);
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.collections;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              const itemLink = `/collections/${item.handle}`;
              return collectionsTemplate({ item, html, components }, itemLink);
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
